export default __webpack_public_path__ + "static/media/card.ce797c3c.svg";